import React, { useRef } from "react";
import { Loader2 } from "lucide-react";
import FieldBox from "@/components/contracts/FieldBox";
import { useAuthBlob } from "@/components/contracts/contractUtils";

function ContractPage({ contract, index, fields, ctx }) {
  const page = contract.pages[index];
  const ref = useRef(null);
  const src = useAuthBlob(`/contracts/${contract.id}/pages/${index}`);
  const click = (e) => {
    if (!ctx.placing) return;
    const r = ref.current.getBoundingClientRect();
    const s = page.w / r.width;
    ctx.onPlace(index, (e.clientX - r.left) * s, (e.clientY - r.top) * s);
  };
  return (
    <div ref={ref} onClick={click} className={`relative bg-white shadow-2xl select-none ${ctx.placing ? "cursor-crosshair ring-2 ring-[var(--ff-red)]" : ""}`}
      style={{ aspectRatio: `${page.w} / ${page.h}` }} data-testid={`contract-page-${index}`}>
      {src
        ? <img src={src} alt={`Page ${index + 1}`} draggable={false} className="absolute inset-0 w-full h-full pointer-events-none" />
        : <div className="absolute inset-0 flex items-center justify-center text-black/40"><Loader2 className="animate-spin" /></div>}
      {fields.map((f) => (
        <FieldBox key={f.id} f={f} page={page} containerRef={ref} mode={ctx.mode} contractId={contract.id}
          selected={ctx.selectedId === f.id} locked={ctx.lockedRoles.has(f.signer)}
          onSelect={ctx.onSelect} onMove={ctx.onMove} sign={ctx.sign} />
      ))}
      <div className="absolute bottom-1.5 right-2.5 text-[10px] font-mono-ui text-black/40">PAGE {index + 1} / {contract.pages.length}</div>
    </div>
  );
}

export default function ContractPages({ contract, fields, ctx }) {
  return (
    <div className="space-y-8" data-testid="contract-pages">
      {contract.pages.map((_, i) => (
        <ContractPage key={i} contract={contract} index={i} fields={fields.filter((f) => f.page === i)} ctx={ctx} />
      ))}
    </div>
  );
}
